import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
/**
 * A singleton service for the current loading status
 */
export class LoadingStatusService {

  /**
   * The current loading status
   */
  public get loading(): boolean {
    // TODO: remove? is this ever actually used?
    return this.loading$.getValue();
  }

  /**
   * Set the current loading status
   */
  public set loading(status: boolean) {
    this.loading$.next(status);
  }

  /**
   * Our loading status as a subject
   */
  public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }
}
